import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button } from "../components/ui/button";

export default function Forbidden() {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F7F8FA] px-6" data-testid="forbidden-page">
      <div className="bg-white border border-slate-200 rounded-2xl p-10 max-w-md text-center shadow-sm">
        <img src="/brand/logo-color.png" alt="" style={{ height: 36, width: "auto" }} className="mx-auto mb-6 opacity-70" />
        <h1 className="text-2xl text-[#0A1F44]" style={{ fontFamily: "'Segoe UI', 'Selawik', Tahoma, Geneva, Verdana, system-ui, sans-serif" }}>{t("forbidden.title")}</h1>
        <p className="text-sm text-slate-500 mt-3">{t("forbidden.subtitle")}</p>
        <Link to="/dashboard">
          <Button className="mt-6 bg-[#C8102E] hover:bg-[#a50d25]" data-testid="forbidden-back-button">{t("forbidden.back")}</Button>
        </Link>
      </div>
    </div>
  );
}
